import { Typography } from '@creditas-ui/typography';
import type { ExtrajudicialNotification } from '../../../types';
import { diffInDays, serializeBrAddress } from '../../../utils/helpers';

type DetailData = {
  key: string;
  renderValue: () => JSX.Element;
  show: () => boolean;
};

export const detailsData = (ejn: ExtrajudicialNotification): DetailData[] => {
  return [
    {
      key: 'Atribuído a',
      renderValue: () => <></>,
      show: () => true,
    },
    {
      key: 'Data da verificação',
      renderValue: () => <></>,
      show: () => true,
    },
    {
      key: 'Motivo da pendência', // denialReason
      renderValue: () => buildText(ejn?.denialReason),
      show: () => true,
    },
    {
      key: 'Data SRO', // preConfirmationDate
      renderValue: () => buildText(ejn?.preConfirmationDate),
      show: () => ejn?.preConfirmationDate != null,
    },
    {
      key: 'Retorno AR', // confirmationDate
      renderValue: () => buildText(ejn?.confirmationDate),
      show: () => ejn?.confirmationDate != null,
    },
    {
      key: 'Destinatário',
      renderValue: () => buildText(ejn?.notification?.participant?.fullName),
      show: () => true,
    },
    {
      key: 'Endereço',
      renderValue: () =>
        buildText(ejn.address ? serializeBrAddress(ejn.address) : ''),
      show: () => true,
    },
    {
      key: 'CPF',
      renderValue: () => buildText(ejn.notification?.participant?.key?.code),
      show: () => true,
    },
    {
      key: 'Início retomada',
      renderValue: () => buildText(ejn.notification?.repossessionStartedDate),
      show: () => true,
    },
    {
      key: 'Nº tentativa',
      renderValue: () => buildText(ejn.attemptNumber),
      show: () => true,
    },
    {
      key: 'Data notificação',
      renderValue: () => buildText(ejn.notification?.createdAt),
      show: () => true,
    },
    {
      key: 'Na fila',
      renderValue: () => {
        const data = ejn?.sentAt
          ? diffInDays(new Date(ejn.sentAt), new Date()).toString()
          : '';
        return buildText(data);
      },
      show: () => true,
    },
    {
      key: 'Dias de atraso',
      renderValue: () => buildText(ejn.notification.overdueDays),
      show: () => true,
    },
    {
      key: 'Fundo',
      renderValue: () => <></>,
      show: () => true,
    },
  ];
};

const buildText = (key: string | number | undefined | null) => (
  <Typography variant={'bodyMdRegular'} color={'neutral.80'}>
    {key}
  </Typography>
);
